var map = {
	"./board_service.js": 73,
	"./board_service.js.es6": 73
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;



//////////////////
// WEBPACK FOOTER
// ./boards/services ^\.\/.*\.(js|es6)$
// module id = 162
// module chunks = 1